import { WebPaymentDto } from './web-payment.dto';

export class WebPaymentResponseDto {
  message?: string;
  success: boolean;
  webPayment?: WebPaymentDto;
  code?: string;
  bankMIDId?: number;
}
